var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 240.62,
    x2: 240.62,
    y1: 512,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5558ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 265.615,
    x2: 265.615,
    y1: 435.491,
    y2: 17.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#addcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaf6ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M256 512c-68.114 0-132.328-26.702-180.813-75.187C26.702 388.328 0 324.114 0 256c0-34.625 6.876-68.256 20.439-99.96a14.992 14.992 0 0 1 14.414-9.087 15 15 0 0 1 13.61 10.251l13.193 39.652 24.583 16.389 4.834-48.726a15 15 0 0 1 8.22-11.936l55.268-27.625 13.252-29.172a15 15 0 0 1 8.135-7.743l24.789-9.814L156.3 44.785a14.999 14.999 0 0 1 3.34-25.867C190.315 6.365 222.736 0 256 0c92.242 0 177.812 50.276 223.315 131.209a14.998 14.998 0 0 1-8.191 21.534l-53.02 18.26a14.987 14.987 0 0 1-7.351.613l-49.66-8.28a15.003 15.003 0 0 1-10.012-6.473l-9.068-13.596-57.058 29.94 34.512 8.199a15 15 0 0 1 9.146 6.475l16.909 26.268 22.668-5.67a14.993 14.993 0 0 1 11.959 2.07l24.83 16.55a15 15 0 0 1 6.681 12.482v27.243l43.93 47.57a15 15 0 0 1 3.98 10.177v81.07a15 15 0 0 1-3.265 9.343c-23.507 29.527-53.731 53.947-87.405 70.622C333.531 503.119 295.545 512 256 512z",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M479.313 131.205a15 15 0 0 0-17.957-6.827l-49.422 17.021-39.499-6.586-12.956-19.426c-4.258-6.386-12.652-8.526-19.449-4.96l-104.49 54.83a15 15 0 0 0 3.503 27.877l67.614 16.064 19.46 30.231a14.997 14.997 0 0 0 16.253 6.432l26.663-6.67 12.627 8.417v25.081a15 15 0 0 0 3.98 10.177l43.93 47.57v75.204a14.999 14.999 0 0 0 26.734 9.344c17.663-22.182 31.424-46.877 40.902-73.401C507.023 314.113 512 285.319 512 256c0-43.635-11.303-86.788-32.687-124.795zm-228.69 150.426-46.843-9.372-39.541-43.49a15.04 15.04 0 0 0-11.297-4.908l-37.658.498 4.826-48.642 52.617-26.3a14.998 14.998 0 0 0 6.95-7.213l12.946-28.496 44.029-17.431a15.001 15.001 0 0 0 3.499-25.931l-65.81-49.53a14.998 14.998 0 0 0-14.706-1.896C97.539 44.353 46.803 94.334 20.436 156.047a15 15 0 0 0-.439 10.629l14.82 44.54a15 15 0 0 0 5.913 7.745l42.97 28.647v32.182c0 3.906 1.523 7.658 4.247 10.458l37.143 38.193v42.389c0 3.509 1.23 6.907 3.477 9.602l41.38 49.66a14.998 14.998 0 0 0 26.523-9.602v-33.88l27.109-20.33c3.777-2.833 6-7.279 6-12v-18.618l28.708-28.717a14.999 14.999 0 0 0-7.664-25.314z",
    opacity: 1,
    "data-original": "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.26063c97820608a158d211e021f62fde.svg";
export { ForwardRef as ReactComponent };